import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { User } from 'src/app/model/settings/user.model';
import { Setting } from '../model/setting.model';
import { Partner } from '../model/settings/partner.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  private path = environment.apiURL + 'partner';

  constructor(private http: HttpClient) {
  }

  public list(): Observable<Array<Partner>> {
    return this.http
               .get<Partner[]>(this.path);
  }

  public get(id: number): Observable<Partner> {
    return this.http
               .get<Partner>(this.path + '/' + id);
  }

  public save(partner: Partner): Observable<Partner> {
    return this.http
               .put<Partner>(this.path,
                             partner);
  }

  public enable(partner: Partner): Observable<void> {
    return this.http
               .patch<void>(this.path + '/' + partner.id + '/enable',
                            null);
  }

  public disable(partner: Partner): Observable<void> {
    return this.http
               .delete<void>(this.path + '/' + partner.id);
  }

  public users(id: number): Observable<Array<User>> {
    return this.http
               .get<Array<User>>(this.path + '/' + id + '/user');
  }

  public params(id: number): Observable<Setting[]> {
    return this.http
               .get<Setting[]>(this.path + '/' + id + '/param');
  }

  public paramsSave(id: number,
                    params: Array<Setting>): Observable<Setting[]> {
    return this.http
               .put<Setting[]>(this.path + '/' + id + '/param',
                             params);
  }

  public synch(): Observable<void> {
    return this.http
               .put<void>(this.path + '/synch',
                          null);
  }
}
